/**
 * Who you are reading, at the top of the conversation.
 *
 * It used to be the rename control too — a pencil on the title and a picker on
 * the picture. Those are things you do *to* a conversation rather than inside
 * one, and WhatsApp keeps them on the row in the list, where a conversation is
 * one of several rather than the one you are reading. They moved there; this
 * is now only a label.
 */
export function ChatTitle({ name, photo, who }: {
  name: string;
  /** An object URL, already decrypted by App, or undefined for the initial. */
  photo?: string;
  /** Everyone who speaks in the transcript, comma-separated. Empty until the
   *  conversation has been decrypted, which is why it is not part of the name. */
  who?: string;
}) {
  return (
    <>
      <span className="chat-photo" aria-hidden="true">
        {photo ? <img src={photo} alt="" /> : <span>{(name.trim()[0] ?? '?').toUpperCase()}</span>}
      </span>
      <span className="chat-name">
        <strong>{name}</strong>
        {who && <span className="roster">{who}</span>}
      </span>
    </>
  );
}
